export {default} from '@/base/pages/404';